interface GetAvailabilityAPMsType {
  isApplePayAvailable: () => boolean;
}

const isApplePayAvailable = (): boolean => {
  return !!window.ApplePaySession; // && ApplePaySession.canMakePayments();
};

const getAvailabilityAPMs = (): GetAvailabilityAPMsType => {
  return {
    isApplePayAvailable,
  };
};

export default getAvailabilityAPMs;
